import Angular from "angular";

let IfDataLoadingModule = Angular.module('if-screen-size', []);

IfDataLoadingModule.directive('ifScreenSize', ['ngIfDirective', 'screenSize', function (ngIfDirective, screenSize) {
    let ngIf = ngIfDirective[0];

    return {
        transclude: ngIf.transclude,
        priority: ngIf.priority - 1,
        terminal: ngIf.terminal,
        restrict: 'EA',

        link: function (scope, element, attributes) {
            let size = attributes.ifScreenSize;

            // find the initial ng-if attribute
            var initialNgIf = attributes.ngIf, ifEvaluator;

            // if it exists, evaluates ngIf && ifAuthenticated
            if (initialNgIf) {
                ifEvaluator = function () {
                    return scope.$eval(initialNgIf) && screenSize.is(size);
                }
            } else { // if there's no ng-if, process normally
                ifEvaluator = function () {
                    return screenSize.is(size);
                }
            }

            attributes.ngIf = ifEvaluator;
            ngIf.link.apply(ngIf, arguments);
        }
    };
}]);

export default IfDataLoadingModule;




// WEBPACK FOOTER //
// ./src/modules/core/directives/if-screen-size.js